<template>
  <div>
    <data-tables :data="users" :filters="filters" :action-col="actionCol">
      <el-row slot="tool" style="margin: 10px 0">
        <el-col :span="5" class="d-flex align-items-center">
          <i class="el-icon-search mr-2" style="font-size: 1.5rem;"></i>
          <el-input v-model="filters[1].value">
        </el-input></el-col>
      </el-row>
      <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label" sortable="custom">
      </el-table-column>
      <el-table-column
        prop="status"
        label="Status"
        width="100"
        :filters="[{ text: 'Paid', value: 'paid' }, { text: 'Unpaid', value: 'unpaid' }]"
        :filter-method="filterStatus"
        filter-placement="bottom-end">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status === 'paid' ? 'success' : 'danger'"
            disable-transitions>{{scope.row.status}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="paymentDate"
        label="Payment Date"
        sortable
        width="180">
      </el-table-column>
    </data-tables>
  </div>
</template>
<script>
export default {
  props: ['onClickReceipt', 'users'],
  data() {
    return {
      titles: [
        {
          prop: 'Email',
          label: 'Email'
        },
        {
          prop: 'First name',
          label: 'First name'
        },
        {
          prop: 'Last name (family name)',
          label: 'Last name'
        },
        {
          prop: 'Fee',
          label: 'Fee'
        },
      ],
      filters: [{
        prop: 'status',
        value: [],
      }, {
        prop: ['Email', 'First name'],
        value: '',
      }],
      actionCol: {
        label: 'Actions',
        props: {
          align: 'center',
        },
        buttons: [{
          props: {
            type: 'primary',
            icon: 'el-icon-tickets'
          },
          handler: row => {
            if (row.status === 'paid') {
              this.$message('Edit clicked')
              this.onClickReceipt(row)
            }
            else {
              this.$message('Invalid User')
            }
          },
          label: 'Receipt'
        }]
      },
    }
  },
  methods: {
    filterStatus(value, row) {
      return row.status === value;
    },
  },
}
</script>

